<!-- 教育局-学生托管统计 -->
<template>
  <div>
    <div class="index">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
        <div class="time">
          <span
            >截止日期:
            {{
              dayjs(new Date().getTime() - 86400000).format("YYYY-MM-DD")
            }}</span
          >
        </div>
      </div>
      <div v-if="!educationType" class="Homeboxtop_nav_tab">
        <span
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.area_name === tabName }]"
          :key="index + item.area_name"
          @click="tabClick(item)"
        >
          {{ item.area_name }}
        </span>
      </div>

      <header class="m-t">
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>学生托管统计</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>近七天学生出勤变化</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header>
      <div class="header-item-title">
        <span class="circle"></span>
        <span>统计明细</span>
      </div>
      <div class="m-t">
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              style="width: 200px"
              v-model="queryParams.semester"
              clearable
              placeholder="选择学年学期"
              class="label"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.endDay"
                :label="item.schooleYearName"
                :value="item.schooleYearName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryParams.time"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="orga_name"
              v-if="!educationType"
              label="区域"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="orga_name"
              v-else
              label="学校"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="stu_td" label="学生总数" align="center">
              <template slot-scope="scope">
                <span> {{ parseInt(scope.row.stu_td) || 0 }} </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="stu_per_td"
              label="生均课程数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="hours_per_td"
              label="生均课时数"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="stu_di_per_td" label="出勤率" align="center">
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  handleStudentSignUp,
  handleStudentAttendance,
  handleDetailedList,
} from "@/api/education/statistical.js";
import api from "@/api/schoolApi/index.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
import util from "@/utils/util.js";
export default {
  components: {},
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        time: "",
      },
      semesterList:[],
      dateTime: "",
      tableData: [],
      // semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      weekDate: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tabList: [],
      tabName: "全省",
      provinceCode: "", // 省编码
      cityCode: "", // 市编码
      areaCode: "", // 区编码
      educationType: sessionStorage.getItem("educationType") === "area",
      Userlist: JSON.parse(window.sessionStorage.getItem("Userlist")),
      studentSignUpData: [
        { value: 0, name: "已报名学生数" },
        { value: 0, name: "未报名学生数" },
      ],
      StudentAttendanceAnswerData: [], //学生应出勤人数
      StudentAttendancecAtualData: [], //学生实际出勤人次
    };
  },
  watch: {
    tabName(n, o) {
      let arr = this.tabList.filter((e) => e.area_name === n);
      if (this.org_type === "p") {
        if (n === "全省") {
          this.cityCode = "";
        } else {
          this.cityCode = arr[0].area_code;
        }
      } else {
        if (n === "全市") {
          this.areaCode = "";
        } else {
          this.areaCode = arr[0].area_code;
        }
      }
    },
  },
  computed: {
    // 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
    org_type() {
      let str = "a";
      if (sessionStorage.getItem("user_level") === "99") {
        str = "p";
      }
      if (["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1) {
        str = "c";
      }
      if (
        ["2", "20", "4", "40"].indexOf(sessionStorage.getItem("user_level")) >
        -1
      ) {
        str = "a";
      }
      return str;
    },
  },
  mounted() {
    // this.semesterList=this.semesterArr.map(v=>({label:v.schoolYear+'第'+v.semester+'学期',id:v.schoolYear+'_'+v.semester}))
    // let arr = [];
    // for (let i = 1; i <= 7; i++) {
    //   const time = new Date(new Date().setDate(new Date().getDate() + i - 7));
    //   const year = time.getFullYear();
    //   const month = `0${time.getMonth() + 1}`.slice(-2);
    //   const strDate = `0${time.getDate()}`.slice(-2);
    //   arr.push(`${month}-${strDate}`);
    // }
    // this.weekDate = arr;
  },
  created() {
    if (this.org_type !== "a") {
      let areaList = JSON.parse(sessionStorage.getItem("areaList")) || [];
      if (this.org_type === "p") {
        this.provinceCode = this.Userlist.province_code;
        this.tabList = [
          { area_name: "全省", parent_code: this.Userlist.province_code },
          ...areaList,
        ];
      } else {
        this.provinceCode = this.Userlist.province_code;
        this.cityCode = this.Userlist.city_code;
        this.tabList = [
          { area_name: "全市", area_code: this.Userlist.city_code },
          ...areaList,
        ];
      }
      this.tabName = this.tabList[0].area_name;
    }

    this.getStatisticalSemester();
    this.getData();
  },
  methods: {
    dayjs,
    async getStatisticalSemester() {
      // 获取学期学年
      let params = {};
      let res = await api.schoolStatisticalSemester(params);
      if (res.result === "000000"  ) {
        console.log("获取学期学年---", res);
        sessionStorage.semesterList=JSON.stringify(res);
        //  console.log("获取学期学年11---", sessionStorage.getItem("semesterList"));
        this.semesterList=res.data || [];
      }
    },
    tabClick(item) {
      // console.log("点击选择--", item, this.org_type);
      this.tabName = item.area_name;
      if (this.org_type == "c") {
        if (item.area_name == "全市") {
          this.Userlist = {
            area_code: "",
            city_code: item.area_code || "",
            province_code: JSON.parse(window.sessionStorage.getItem("Userlist"))
              .province_code,
          };
        } else {
          this.Userlist = {
            area_code: item.area_code || "",
            city_code: item.parent_code || "",
            province_code: JSON.parse(window.sessionStorage.getItem("Userlist"))
              .province_code,
          };
        }
      } else if (this.org_type == "p") {
        this.Userlist = {
          area_code: "",
          city_code: item.area_code || "",
          province_code: item.parent_code,
        };
      }
      this.getData();
    },
    async getData() {
      this.getNowDate();
      this.getStudentSignUp();
      this.getStudentAttendance();
      this.getDetailedList();
    },
    async getStudentSignUp() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: "", //2021-2022学年上学期
          dataRange: "td", //统计周期
        };
        let { code, data } = await handleStudentSignUp(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            this.studentSignUpData[0].value =
              data.rows[0].stu_sign_num === null
                ? 0
                : data.rows[0].stu_sign_num;
            this.studentSignUpData[1].value =
              data.rows[0].no_stu_sign_num === null
                ? 0
                : data.rows[0].no_stu_sign_num;
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getStudentAttendance() {
      this.StudentAttendanceAnswerData = [];
      this.StudentAttendancecAtualData = [];
      this.weekDate = [];
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: "", //2021-2022学年上学期
          dataRange: "td", //统计周期
        };
        let { code, data } = await handleStudentAttendance(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            data.rows.forEach((item) => {
              if (item.s == "学生应出勤人数") {
                this.StudentAttendanceAnswerData.push(item.stu_nu);
              } else {
                this.StudentAttendancecAtualData.push(item.stu_nu);
              }
              if (item.op_time != "") {
                var str = item.op_time.substring(item.op_time.length - 4);
                item.op_time = str.slice(0, 2) + "-" + str.slice(2);
              }
              if (this.weekDate.indexOf(item.op_time) == -1) {
                this.weekDate.push(item.op_time);
              }
            });
          } else {
            this.StudentAttendanceAnswerData = [0];
            this.StudentAttendancecAtualData = [0];
            this.weekDate = ["无数据"];
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getDetailedList() {
      try {
        let params = {
          date: this.dateTime, //统计日期,
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          prd_name: "", //学段名称 小学
          yearly_semester: this.queryParams.semester, //2021-2022学年上学期
          pagenum: this.pageNum,
          pagesize: this.pageSize,
        };
        let { code, data } = await handleDetailedList(params);
        if (code === "0") {
          if (data.rows) {
            this.tableData = data.rows;
            this.totalPage = data.total;
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
      }
    },
    searchFun() {
      if (this.queryParams.time != "" && this.queryParams.time != null) {
        // console.log('进入查询---',this.queryParams.time);
        let data = this.queryParams.time.replace("-", "");
        this.dateTime = data.replace("-", "");
      }
      this.tableData = [];
      this.totalPage = 0;
      this.pageNum = 1;
      this.getDetailedList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDetailedList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDetailedList();
    },
    // 获取当前一天的数据
    getNowDate() {
      this.dateTime = util.getNowDate();
      this.queryParams.time = util.getNowDateRung();
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById("echarts-box1");
        let myChart1 = echarts.init(chartDom1);
        let option1 = {
          legend: {
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          tooltip: {
            trigger: "axis",
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["38%", "50%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: "#fff",
                borderWidth: 0,
              },
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: this.studentSignUpData,
            },
          ],
          // 圆环颜色
          color: ["#5BB0FF", "#51D6A6"],
        };
        myChart1.setOption(option1);

        // 折线图
        let chartDom2 = document.getElementById("echarts-box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          legend: {
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.weekDate,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: "学生实际出勤数",
              type: "line",
              data: this.StudentAttendancecAtualData,
            },
            {
              name: "学生应出勤数",
              type: "line",
              data: this.StudentAttendanceAnswerData,
            },
          ],
          color: ["#5BB0FF", "#51D6A6"],
        };
        myChart2.setOption(option2);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
    .time {
      font-weight: normal;
      margin-left: 67%;
      color: #606266;
      font-size: 14px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 200px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }

  header {
    width: 100%;
    height: 350px;
    display: flex;
    .header-item {
      width: 50%;

      .header-item-text {
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1 {
      width: 80%;
      height: 280px;
    }
    #echarts-box2 {
      width: 90%;
      height: 280px;
    }
  }
  .header-item-title {
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
    .circle {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #4991e1;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .Homeboxtop_nav_tab {
    span {
      padding-bottom: 10px;
    }
  }
}
</style>
